/**
 * One-shot handoff for Chat's ticket-key redirect (Chat has no per-ticket
 * data; a mentioned ticket key routes the user to Issue Analysis instead).
 *
 * Deliberately its own tiny store, not folded into `ticketChatStore` —
 * that store's `returnTo` field drives an unrelated flow (closing the
 * in-ticket chat side panel) and auto-running intake on a 404 there would
 * be an unwanted side effect on a feature this has nothing to do with.
 *
 * In-memory only: the handoff only needs to survive a single hash
 * navigation within the running SPA, not a page reload.
 */
import { create } from 'zustand';

interface ChatRedirectState {
  pendingTicketKey: string | null;
  setPendingTicketKey: (ticketKey: string) => void;
  /** Consumed once by Issue Analysis on mount. */
  takePendingTicketKey: () => string | null;
}

export const useChatRedirectStore = create<ChatRedirectState>()((set, get) => ({
  pendingTicketKey: null,
  setPendingTicketKey: (ticketKey) => set({ pendingTicketKey: ticketKey }),
  takePendingTicketKey: () => {
    const key = get().pendingTicketKey;
    if (key) set({ pendingTicketKey: null });
    return key;
  },
}));
